import React, { Component } from "react";
import { connect } from "react-redux";
import QuestionNumber from "./../QuestionNumber";

import { nextQuestion } from "./../../actions/assessment";
import config from "./../../config/config-secret.json";

import axios from "axios";
import { Translate } from "react-redux-i18n";
import Webcam from "react-webcam";

let count = 0;

export class ImageComparison extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_choices: [],
    };

    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    count = 0;
    // SaveUserStateToServerHelper(this.props.assessment);
  }

  handleSelectedChoice = (e) => {
    const selected_choices = this.state.selected_choices;
    const isSelected =
      e.target.parentNode.parentNode.classList.contains("active");
    const choice_id = e.currentTarget.dataset.choiceid;
    let index;

    if (isSelected) {
      selected_choices.push(+choice_id);
    } else {
      index = selected_choices.indexOf(+choice_id);
      selected_choices.splice(index, 1);
    }

    this.setState({ selected_choices });

    console.log(this.state.selected_choices);
  };

  handleNextQuestion = (e) => {
    if (!!!this.state.selected_choices.length) {
      return alert(<Translate value="imgComp_more" />);
    }

    if (this.props.assessment.has_security_features) {
      this.addCaptureImage(this.webcamRef.current.getScreenshot(), new Date());
    }

    const choice_ids = this.state.selected_choices;
    this.setState({ selected_choices: [] });

    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, choice_ids);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.error(error);

          // Get readable message from server if available
          const serverMessage =
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "Unknown error";

          alert(
            `There appears to be a problem sending data to our server.
Please check your internet connection and try refreshing your browser.

Error details: ${serverMessage}

If the issue persists, please contact your administrator.`
          );
        });
    }
  };

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{
              position: "absolute",
              right: "100%",
              display: "block",
            }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <QuestionNumber />

        <p className="quesion-sub">
          {/* Select the option below that conforms to the following rules. */}
        </p>
        <div className="row">
          <div className="col-md-6 col-lg-6 justify-content-center align-self-center">
            <h4>
              <span>
                <Translate value="imgComp_not" />
              </span>
            </h4>
          </div>

          <div className="col-md-6 col-lg-6 q-img">
            <img
              src={this.props.questionimage}
              alt="test"
              className="img-thumbnail"
              style={{
                height: "200px",
                width: "230px",
                border: "5px solid #ffc107",
              }}
            />
          </div>
        </div>

        <div className="choices-btn choice-comparison" data-toggle="buttons">
          {!!this.props.choices &&
            this.props.choices.map((value, index) => {
              return (
                <label
                  key={value.id}
                  className="btn btn-outline-warning thick-border"
                  onClick={this.handleSelectedChoice}
                  data-choiceid={value.id}
                >
                  <div key={value.id} className="custom-control custom-radio">
                    <input
                      type="checkbox"
                      key={value.id}
                      id={"chkChoice" + value.id}
                      name="choices"
                      className="btn btn-default with-gap d-none checkbox-choices"
                    />
                    <img
                      src={config.API_DOMAIN + value.choice.image}
                      alt="choice"
                      className="img-thumbnail"
                      style={{ height: "150px", width: "150px" }}
                    />
                  </div>
                </label>
              );
            })}
        </div>
        <button
          className="btn btn-outline-light btn-lg mt-3"
          type="button"
          onClick={this.handleNextQuestion}
        >
          <Translate value="imgComp_select" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageComparison);
